'use strict';

class ParticipantMatch {
  constructor($scope, $location, recipientService) {
    this.$scope = $scope;
    this.$location = $location;
    this.recipientService = recipientService;
  }

  $onInit() {
    this.participant = {};
    this.recipients = {};
    this.q = null;

    this.load();

    this.isMerge = false;
  }

  $onChanges(changes) {
    if (changes.currentValue) {
      this.load();
    }
  }

  load() {
    this.recipientService.searchBasedOnParticipant()
      .then((resp) => {
        this.recipients = resp.data.recipient;

        if (!this.recipients.length) {
          this.isMerge = false;
          this.toggle(null, true);
        }
      });
  }

  search() {
    if (this.q.length > 1) {
      this.recipientService.search(this.q, 50)
        .then((resp) => {
          this.recipients = resp.data.recipients;
        });
    }
  }

  toggle(recipient, create = false) {
    this.recipients.forEach((r) => {
      r.selected = false;
      return r;
    });

    if (!create && recipient) {
      this.$scope.$broadcast('recipientNumber', recipient.number);
      this.$scope.$emit('recipientNumber', recipient.number);
    } else {
      this.broadcast(create);
    }
  }

  broadcast(create = false) {
    this.$scope.$broadcast('newRecipient', create);
    this.$scope.$emit('newRecipient', create);
    this.$scope.$broadcast('recipientNumber', null);
    this.$scope.$emit('recipientNumber', null);
  }
}

ParticipantMatch.$inject = ['$scope', '$location', 'recipientService'];

const participantMatch = {
  bindings: {
    participant: '<'
  },
  controller: ParticipantMatch,
  template: `
    <div class="row">
      <div class="large-6 columns">
        <div class="panel" ng-click="$ctrl.isMerge = true; $ctrl.broadcast()" ng-class="{ callout: $ctrl.isMerge }">
          <i class="fa left" ng-class="{ 'fa-check-square-o': $ctrl.isMerge, 'fa-square-o': !$ctrl.isMerge }"></i>
          <h4>
            Koble til eksisterende kunde
            <br>
            <small>{{ $ctrl.recipients.length }} mulige treff</small>
          </h4>
        </div>
      </div>

      <div class="large-6 columns">
        <div class="panel" ng-click="$ctrl.isMerge = false; $ctrl.toggle(null, true)" ng-class="{ callout: !$ctrl.isMerge }">
          <i class="fa left" ng-class="{ 'fa-check-square-o': !$ctrl.isMerge, 'fa-square-o': $ctrl.isMerge }"></i>
          <h4>
            Opprett ny kunde
            <br>
            <small>Basert p&aring; fakturainformasjonen</small>
          </h4>
        </div>
      </div>
    </div>

    <fieldset ng-show="$ctrl.isMerge">
      <h3 class="subheader">Koble til eksisterende kunde</h3>

      <p><i class="fa fa-exclamation-triangle"></i> Kundelisten blir oppdatert med informasjonen deltageren registrerte.</p>

      <input type="search" id="searchRecipient" name="searchRecipient" autocomplete="off" ng-model="$ctrl.q" ng-change="$ctrl.search()" placeholder="S&oslash;k i kundeliste">

      <table class="hovered" ng-show="$ctrl.recipients.length">
        <tr ng-repeat="recipient in $ctrl.recipients track by $index" ng-click="$ctrl.toggle(recipient); recipient.selected = !recipient.selected">
          <td>
            <i class="fa" ng-class="{ 'fa-square-o': !recipient.selected, 'fa-check-square-o': recipient.selected }"></i>
          </td>
          <td>{{ recipient.customerNumber }}</td>
          <td>{{ recipient.name }}</td>
          <td>{{ recipient.contact.address.address1 }}</td>
          <td>{{ recipient.contact.email }}</td>
          <td>{{ recipient.contact.phone }}</td>
          <td class="right-align">
            <a role="button" class="button secondary" href="#/kunde/{{ recipient.number }}"><i class="fa fa-eye"></i> Vis</a>
          </td>
        </tr>
      </table>
    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('participantMatch', participantMatch);
